import { USER_ACTION, USER_ACTION_ADD } from '../types';

export const userAction = (payload) => ({
    type: USER_ACTION,
    payload,
});

export const userActionAdd = (payload) => ({
    type: USER_ACTION_ADD,
    payload,
});  // export const userActionAdd = (payload) => ({ type: USER_ACTION_ADD,